import React from 'react';
import LocationTemplate from './LocationTemplate';

const SeaboardPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Seaboard"
      stateName="North Carolina"
      countyName="Northampton"
      zipCodes={["27876"]}
      latitude={36.4846}
      longitude={-77.4286}
      population={704}
      historicalFact="Named after the Seaboard Air Line Railway, incorporated in 1907 as a railroad town."
      nearbyTowns={[
        "Roanoke Rapids, NC",
        "Rich Square, NC",
        "Jackson, NC",
        "Weldon, NC",
        "Garysburg, NC",
        "Woodland, NC",
        "Conway, NC",
        "Gaston, NC"
      ]}
    />
  );
};

export default SeaboardPage;